// extracted by mini-css-extract-plugin
module.exports = {"pillWrapper":"Pill_pillWrapper__1vMAv"};